import React, { useEffect } from 'react';

function Amanities({ formData, setFormData }) {
  // Add useEffect to monitor incoming formData
  useEffect(() => {
    // console.log('Amenities formData:', formData);
  }, [formData]);

  const handleChange = (e) => {
    const { id, type, checked, value } = e.target; // Added value to destructuring
    // console.log(`Checkbox ${id} changed to:`, checked);

    setFormData((prevData) => ({
      ...prevData,
      [id]: type === 'checkbox' ? checked : value,
    }));
  };

  return (
    <>
      <hr className="border-t border-gray-300 mb-4" />
      <h2 className="text-gray-800 text-lg font-semibold mt-6 mb-4">Amenities</h2>
      <div className="grid grid-cols-1 sm:grid-cols-4 gap-4 mb-6">
        {/* Library checkbox */}
        <div className="flex items-center space-x-2">
          <input
            type="checkbox"
            id="library"
            checked={Boolean(formData.library)}
            onChange={handleChange}
            className="form-checkbox h-5 w-5 text-blue-600 border-gray-300 rounded"
          />
          <span className="text-gray-700 text-md">Library</span>
        </div>

        {/* Sports Facilities checkbox */}
        <div className="flex items-center space-x-2">
          <input
            type="checkbox"
            id="sportsFacilities"
            checked={Boolean(formData.sportsFacilities)}
            onChange={handleChange}
            className="form-checkbox h-5 w-5 text-blue-600 border-gray-300 rounded"
          />
          <span className="text-gray-700 text-md">Sports Facilities</span>
        </div>

        {/* Third Checkbox: Accommodation */}
        <div className="flex items-center space-x-2">
          <input
            type="checkbox"
            id="accomodation"
            checked={Boolean(formData.accomodation)}
            onChange={handleChange}
            className="form-checkbox h-5 w-5 text-blue-600 border-gray-300 rounded"
          />
          <span className="text-gray-700 text-md">Accommodation</span>
        </div>

        {/* Fourth Checkbox: University Transport */}
        <div className="flex items-center space-x-2">
          <input
            type="checkbox"
            id="univerityTransport"
            checked={Boolean(formData.univerityTransport)}
            onChange={handleChange}
            className="form-checkbox h-5 w-5 text-blue-600 border-gray-300 rounded"
          />
          <span className="text-gray-700 text-md">University Transport</span>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-4 gap-4 mb-6">
        {/* Fifth Checkbox: Public Transport */}
        <div className="flex items-center space-x-2">
          <input
            type="checkbox"
            id="nearbyPublicTransport"
            checked={Boolean(formData.nearbyPublicTransport)}
            onChange={handleChange}
            className="form-checkbox h-5 w-5 text-blue-600 border-gray-300 rounded"
          />
          <span className="text-gray-700 text-md">Near By Public Transport</span>
        </div>

        {/* Sixth Checkbox: Student Union */}
        <div className="flex items-center space-x-2">
          <input
            type="checkbox"
            id="studentUnion"
            checked={Boolean(formData.studentUnion)}
            onChange={handleChange}
            className="form-checkbox h-5 w-5 text-blue-600 border-gray-300 rounded"
          />
          <span className="text-gray-700 text-md">Student Union</span>
        </div>
      </div>
    </>
  );
}

export default Amanities;